import { render, staticRenderFns } from "./TableStatCard.vue?vue&type=template&id=a13f45c6&scoped=true&"
import script from "./TableStatCard.vue?vue&type=script&lang=js&"
export * from "./TableStatCard.vue?vue&type=script&lang=js&"
import style0 from "./TableStatCard.vue?vue&type=style&index=0&id=a13f45c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13f45c6",
  null
  
)

export default component.exports